import { useContext, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { TimeEditor } from 'src/app/modules/component/time-editor/TimeEditor'
import { useTimeEditorManager } from 'src/app/modules/component/time-editor/useTimeEditorManager'
import { hasAuthority, KEY_AUTHORITIES } from 'src/app/modules/utils/Permission'
import CustomTabMenu from '../../../../component/CustomTabMenu'
import { DS_NOI_TRU_TIEP_DON } from '../../../../utils/Constant'
import { calculateAge, formatDateTime } from '../../../../utils/FormatUtils'
import { dsTabThongTinNoiTru } from '../../../const/PhanHeNoitruConst'
import { PhanHeNoiTruContext } from '../../../PhanHeNoiTruContext'
import { updateTreatmentFields } from '../../../services/Common'

type Props = {}

const BenhNhan = (props: Props) => {
  const { benhNhanHanhChinh, setBenhNhanHanhChinh } = useContext(PhanHeNoiTruContext);
  const [activeTabNoiTru, setActiveTabNoiTru] = useState<string>("0");
  const [isExpand, setIsExpand] = useState(false);

  const allowEdit = !benhNhanHanhChinh?.concluded && hasAuthority(KEY_AUTHORITIES.UPDATE_FIELDS.DIEU_TRI);

  const onUpdate = (updatedData: any, field: string) => {
    if (!updatedData?.[field]) return;

    setBenhNhanHanhChinh({
      ...benhNhanHanhChinh,
      [field]: updatedData[field]
    })
  };

  const visitDateStartedManager = useTimeEditorManager({
    name: "visitDateStarted",
    idFieldName: "treatmentId",
    values: benhNhanHanhChinh,
    updateFields: updateTreatmentFields,
    onUpdateSuccess: (updatedData) => onUpdate(updatedData, "visitDateStarted")
  });

  const startDateManager = useTimeEditorManager({
    name: "startDate",
    idFieldName: "treatmentId",
    values: benhNhanHanhChinh,
    updateFields: updateTreatmentFields,
    onUpdateSuccess: (updatedData) => onUpdate(updatedData, "startDate")
  });

  const endDateManager = useTimeEditorManager({
    name: "endDate",
    idFieldName: "treatmentId",
    values: benhNhanHanhChinh,
    updateFields: updateTreatmentFields,
    onUpdateSuccess: (updatedData) => onUpdate(updatedData, "endDate")
  });

  return (
    <>
      <div className='spaces px-16 py-5'>
        <Row>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Mã BN
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.patientCode || "..."}
              </span>
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Mã HSBA
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.medicalRecordCode || "..."}
              </span>
            </div>
          </Col>
          <Col xs="6">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Bệnh nhân
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.patientName ? (
                  <>
                    <span>
                      {benhNhanHanhChinh?.patientName || "..."} -{" "}
                      {benhNhanHanhChinh?.gender || "..."} -{" "}
                      {benhNhanHanhChinh?.visitObjectTypeName || "..."}
                    </span>
                  </>
                ) : (
                  "..."
                )}
              </span>
            </div>
          </Col>

          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Ngày sinh
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.dobYear
                  ? benhNhanHanhChinh?.dobYear + " - " + calculateAge(
                    benhNhanHanhChinh?.dobDay,
                    benhNhanHanhChinh?.dobMonth,
                    benhNhanHanhChinh?.dobYear
                  )
                  : "..."}
              </span>
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Thời điểm tới
              </span>
              <TimeEditor
                name="visitDateStarted"
                values={benhNhanHanhChinh}
                isEditingTime={visitDateStartedManager.isEditingTime}
                editedTime={visitDateStartedManager.editedTime}
                showValidationConfirm={visitDateStartedManager.showValidationConfirm}
                validationMessage={visitDateStartedManager.validationMessage}
                onEdit={visitDateStartedManager.handleEditTime}
                onCancel={visitDateStartedManager.handleCancelEdit}
                onSave={visitDateStartedManager.handleSaveTime}
                onConfirmValidation={visitDateStartedManager.handleConfirmValidation}
                onCancelValidation={visitDateStartedManager.handleCancelValidation}
                onTimeChange={visitDateStartedManager.setEditedTime}
                allowEdit={allowEdit}
              />
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Loại đón tiếp
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.visitTypeName || "..."}
              </span>
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Đối tượng
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.visitObjectTypeName || "..."}
              </span>
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Số vào viện:
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.inHospitalNumber || "..."}
              </span>
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Số vào khoa:
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.inDeptNumber || "..."}
              </span>
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Mã điều trị:
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.treatmentCode || "..."}
              </span>
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Nhóm máu:
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.bloodType || "..."}
              </span>
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Lý do khám:
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.treatmentReason || "..."}
              </span>
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Bệnh án:
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.recordTypeName || "..."}
              </span>
            </div>
          </Col>
          <Col xs="6">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                TTPK:
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.roomName ? (
                  <>
                    <span>
                      {benhNhanHanhChinh?.roomName || "..."} -{" "}
                      {benhNhanHanhChinh?.chamberName || "..."} -{" "}
                      {benhNhanHanhChinh?.bedName || "..."}
                    </span>
                  </>
                ) : (
                  "..."
                )}
              </span>
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Ngày vào:
              </span>
              <TimeEditor
                name="startDate"
                values={benhNhanHanhChinh}
                isEditingTime={startDateManager.isEditingTime}
                editedTime={startDateManager.editedTime}
                showValidationConfirm={startDateManager.showValidationConfirm}
                validationMessage={startDateManager.validationMessage}
                onEdit={startDateManager.handleEditTime}
                onCancel={startDateManager.handleCancelEdit}
                onSave={startDateManager.handleSaveTime}
                onConfirmValidation={startDateManager.handleConfirmValidation}
                onCancelValidation={startDateManager.handleCancelValidation}
                onTimeChange={startDateManager.setEditedTime}
                allowEdit={allowEdit && benhNhanHanhChinh?.assigned}
              />
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Ngày ra:
              </span>
              <TimeEditor
                name="endDate"
                values={benhNhanHanhChinh}
                isEditingTime={endDateManager.isEditingTime}
                editedTime={endDateManager.editedTime}
                showValidationConfirm={endDateManager.showValidationConfirm}
                validationMessage={endDateManager.validationMessage}
                onEdit={endDateManager.handleEditTime}
                onCancel={endDateManager.handleCancelEdit}
                onSave={endDateManager.handleSaveTime}  
                onConfirmValidation={endDateManager.handleConfirmValidation}
                onCancelValidation={endDateManager.handleCancelValidation}
                onTimeChange={endDateManager.setEditedTime}
                allowEdit={allowEdit && benhNhanHanhChinh?.concluded}
              />
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Số ngày ĐT:
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.treatmentDays || "0"}
              </span>
            </div>
          </Col>
          <Col xs="3">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Bác sĩ ĐT:
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.doctorName || "..."}
              </span>
            </div>
          </Col>
          <Col xs="6">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Chẩn đoán:
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.icd10ProvisionalDiagnosisName || "..."}
              </span>
            </div>
          </Col>
          <Col xs="6">
            <div className="spaces fw-5 mb-8 d-flex">
              <span className="d-inline-block spaces min-w-100 fw-bold">
                Xử trí:
              </span>
              <span className="spaces fw-4 text-truncate">
                {benhNhanHanhChinh?.concluded
                  ? `${benhNhanHanhChinh?.medicalConclusionModalityName
                    ? benhNhanHanhChinh?.medicalConclusionModalityName + " - "
                    : ""
                  } 
                      ${benhNhanHanhChinh?.medicalConclusionName || ""}`
                  : "..."}
              </span>
            </div>
          </Col>
        </Row>
        <Row>
          {isExpand && <>

            <Col xs="3">
              <div className="spaces fw-5 mb-8 d-flex">
                <span className="d-inline-block spaces min-w-100 fw-bold">
                  CMND/CCCD
                </span>
                <span className="spaces fw-4 text-truncate">
                  {benhNhanHanhChinh?.patientIdNumber || "..."}
                </span>
              </div>
            </Col>
            <Col xs="3">
              <div className="spaces fw-5 mb-8 d-flex">
                <span className="d-inline-block spaces min-w-100 fw-bold">
                  Dân tộc-QT
                </span>
                <span className="spaces fw-4 text-truncate">
                  {benhNhanHanhChinh?.ethnicityName || "..."}
                </span>
              </div>
            </Col>
            <Col xs="3">
              <div className="spaces fw-5 mb-8 d-flex">
                <span className="d-inline-block spaces min-w-100 fw-bold">
                  Nghề nghiệp
                </span>
                <span className="spaces fw-4 text-truncate">
                  {benhNhanHanhChinh?.occupationName || "..."}
                </span>
              </div>
            </Col>
            <Col xs="3">
              <div className="spaces fw-5 mb-8 d-flex">
                <span className="d-inline-block spaces min-w-100 fw-bold text-pri">
                  Người nhà
                </span>
                <span className="spaces fw-4 text-truncate">...</span>
              </div>
            </Col>
            <Col xs="6">
              <div className="spaces fw-5 mb-8 d-flex">
                <span className="d-inline-block spaces min-w-100 fw-bold">
                  TT liên lạc
                </span>
                <span className="spaces fw-4 text-truncate">
                  {benhNhanHanhChinh?.contact || "..."}
                </span>
              </div>
            </Col>
            <Col xs="3">
              <div className="spaces fw-5 mb-8 d-flex">
                <span className="d-inline-block spaces min-w-100 fw-bold text-danger">
                  Số BHYT
                </span>
                <span className="spaces fw-4 text-truncate">
                  {benhNhanHanhChinh?.bhytCode || "..."}
                </span>
              </div>
            </Col>
            <Col xs="3">
              <div className="spaces fw-5 mb-8 d-flex">
                <span className="d-inline-block spaces min-w-100 fw-bold text-danger">
                  Hạn thẻ
                </span>
                <span className="spaces fw-4 text-truncate">
                  {benhNhanHanhChinh?.bhytExpireDate || "..."}
                </span>
              </div>
            </Col>
            <Col xs="3">
              <div className="spaces fw-5 mb-8 d-flex">
                <span className="d-inline-block spaces min-w-100 fw-bold text-danger">
                  Tuyến BHYT
                </span>
                <span className="spaces fw-4 text-truncate">{benhNhanHanhChinh?.bhytLevelName || "..."}</span>
              </div>
            </Col>
            <Col xs="3">
              <div className="spaces fw-5 mb-8 d-flex">
                <span className="d-inline-block spaces min-w-100 fw-bold text-danger">
                  Mức hưởng
                </span>
                <span className="spaces fw-4 text-truncate">
                  {benhNhanHanhChinh?.bhytCoveragePercentage
											? `${benhNhanHanhChinh?.bhytCoveragePercentage}%`
											: '...'}
                </span>
              </div>
            </Col>
          </>}
          <Col xs="12" className="d-flex flex-center">
            <Button className="btn-outline" onClick={() => setIsExpand(!isExpand)}>
              <i className={`bi bi-arrow-${isExpand ? "up": "down"}-short`}></i>
              {isExpand ? "Thu gọn" : "Mở rộng"}
            </Button>
          </Col>
        </Row>
      </div>
      <div className="p-0">
        <CustomTabMenu
          danhsachTabs={dsTabThongTinNoiTru}
          keyDanhSachTabs={DS_NOI_TRU_TIEP_DON}
          activeTab={activeTabNoiTru}
          onTabChange={(activeTab: any) => setActiveTabNoiTru(activeTab)}
        />
      </div>
    </>
  )
}

export default BenhNhan